import { render } from "./ArchiveGoalActivityBadge.vue?vue&type=template&id=76c425f4&scoped=true"
import script from "./ArchiveGoalActivityBadge.vue?vue&type=script&lang=js"
export * from "./ArchiveGoalActivityBadge.vue?vue&type=script&lang=js"

import "./ArchiveGoalActivityBadge.vue?vue&type=style&index=0&id=76c425f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-76c425f4"

export default script